/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Video_DescInputs */



/**
* | output |
* | --- |
* | "Burn captions into video" |
*
* @param {File_Export_Video_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_video_desc = /** @type {((inputs?: File_Export_Video_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Video_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Incruster les sous-titres dans la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel in das Video einbrennen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Masterizza i sottotitoli nel video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встраивание субтитров в видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grabar subtítulos en el vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕嵌入视频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画に字幕を焼き込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो में कैप्शन जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporar legendas ao vídeo")
	return /** @type {LocalizedString} */ ("Burn captions into video")
});